import { ThinkingOrb } from "./ThinkingOrb";

/**
 * One visible wait, using the person's existing Cleo indicator and motion
 * choice. HIG6 (GOALS/GOALS-DESIGN.html#hig6): the wait is a live status
 * region — assistive technology hears the specific label ("Reading the three
 * files you included"), never a vague "Processing". The orb is decorative
 * here; the text carries the meaning.
 */
export function CleoWaitIndicator({ label }: { readonly label: string }) {
  return (
    <div
      className="flex flex-col items-center gap-3 text-sm text-muted-foreground"
      data-cleo-wait=""
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span aria-hidden="true">
        <ThinkingOrb
          label={label}
          size={36}
          fallback={
            <span className="flex h-9 items-center gap-1.5">
              <span className="size-1.5 rounded-full bg-current opacity-50" />
              <span className="size-1.5 rounded-full bg-current opacity-75" />
              <span className="size-1.5 rounded-full bg-current" />
            </span>
          }
        />
      </span>
      <span data-cleo-wait-label="">{label}</span>
    </div>
  );
}
